import api from "./axios";
import { API_ENDPOINTS } from "../constants";
import { encryptJourneyQueryValue } from "../common/utils/journeyEncryption";

const asObject = (data) => {
  if (data == null) return data;
  if (typeof data === "string") {
    const trimmed = data.trim();
    if (trimmed.startsWith("{") && trimmed.endsWith("}")) {
      try {
        return JSON.parse(trimmed);
      } catch {
        return { message: data };
      }
    }
    return { message: data };
  }
  return data;
};

/**
 * Uses the existing journey OTP APIs. A source policy number tells the server to
 * call GetLatestPolicyInfo and send the OTP to that policy's mobile.
 * The browser does not send a destination number.
 */
export const sendTransferOfFundsOtp = async ({
  policyNumber,
  applicationNumber,
  customerName,
}) => {
  const response = await api.post(API_ENDPOINTS.TERM_JOURNEY_GENERATE_OTP, {
    policyNumber: String(policyNumber || "").trim(),
    applicationNumber: applicationNumber
      ? encryptJourneyQueryValue(applicationNumber)
      : undefined,
    customerName: customerName || undefined,
    productLob: "nischit-pension",
  });
  return asObject(response?.data);
};

/**
 * Uses the existing journey OTP verify API. The server checks the code against
 * the mobile it resolved for this policy. No mobile identifier is sent.
 */
export const verifyTransferOfFundsOtp = async ({
  policyNumber,
  applicationNumber,
  otp,
}) => {
  const response = await api.post(API_ENDPOINTS.TERM_JOURNEY_VERIFY_OTP, {
    policyNumber: String(policyNumber || "").trim(),
    applicationNumber: applicationNumber
      ? encryptJourneyQueryValue(applicationNumber)
      : undefined,
    otp,
  });
  return asObject(response?.data);
};
